import { IconName } from '@fortawesome/fontawesome-common-types';
import { ActionType } from 'typesafe-actions';
import { DialogAction } from '@smart-builder/types';
import { SBButtonVariant } from '../../base/SBButton';
import { DialogResult } from '../types';

// These constants are used in U_AnswerProviderWeb.pas
export const dialogActionCaptions: Record<DialogAction, string> = {
  [DialogAction.Ok]: 'Ok',
  [DialogAction.Yes]: 'Yes',
  [DialogAction.YesToAll]: 'Yes to All',
  [DialogAction.No]: 'No',
  [DialogAction.NoToAll]: 'No to All',
  [DialogAction.Cancel]: 'Cancel',
};

export const dialogActionVariants: Record<DialogAction, SBButtonVariant> = {
  [DialogAction.Ok]: 'primary',
  [DialogAction.Yes]: 'primary',
  [DialogAction.YesToAll]: 'primary',
  [DialogAction.No]: 'secondary',
  [DialogAction.NoToAll]: 'secondary',
  [DialogAction.Cancel]: 'secondary',
};

// These constants are used in U_AnswerProviderWeb.pas
export enum DialogType { // Determines default class name and image.
  Custom = 'custom',
  None = 'none',
  Information = 'information',
  Warning = 'warning',
  Error = 'error',
  Confirmation = 'confirmation',
}

export const dialogTypeClassNames: Record<DialogType, string> = {
  [DialogType.Custom]: 'custom',
  [DialogType.None]: 'none',
  [DialogType.Information]: 'info',
  [DialogType.Warning]: 'warn',
  [DialogType.Error]: 'error',
  [DialogType.Confirmation]: 'confirm',
};

export const dialogTypeIcons: Record<DialogType, IconName | undefined> = {
  [DialogType.Custom]: undefined,
  [DialogType.None]: undefined,
  [DialogType.Information]: 'info-circle',
  [DialogType.Warning]: 'exclamation-triangle',
  [DialogType.Error]: 'exclamation-circle',
  [DialogType.Confirmation]: 'info-circle', // TODO AM needs a question icon
};

export type DialogBody = {
  title?: string;
  message: string;
  dialogType?: DialogType;
  icon?: IconName;
};

type DialogButton = {
  action: DialogAction;
  caption: string;
  variant: SBButtonVariant;
  autoFocus: boolean;
};

export type OptionalDialog = {
  key: string;
  result: DialogAction;
};

export type DialogElem = {
  body?: DialogBody;
  bodyOverride?: JSX.Element;
  buttons: DialogButton[];

  priority?: number; // when attempting to show a dialog while another dialog is active, the higher priority dialog will be showed on top
  className?: string;
  closeOnBackground: boolean;

  optional?: OptionalDialog;

  onResolve: (result: DialogResult) => void;
};

export type DialogsState = {
  dialogs: DialogElem[]; // a list of dialogs, in priority order - the first elem is the highest priority
};

export type DialogsHandler<TAction> = (
  state: DialogsState,
  action: ActionType<TAction>,
) => DialogsState;
